<template>
	<div class="page padded">
		<h1>404</h1>
		<p>The page you were looking for could not be found</p>
		<p><router-link :to="this.org ? '/'+this.org.id : '/'" class="btn-a" >Return to {{ this.org ? this.org.name : 'my'  }} home</router-link></p>
	</div>
</template>

<script>

	export default {
		props : ['org'],
	}

</script>